'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = translate_pipo;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    list: {}
};

function translate_pipo() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_REQUEST:
        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_FAIL:
            return state;
            break;
        case _constants.TranslatePipoConstants.TRANSLATE_PIPO_SUCCESS:
            return (0, _extends3.default)({}, state, {
                list: action.result
            });
            break;

        default:
            return state;
            break;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/translate_pipo.js
// module id = 1915
// module chunks = 0